import styled from 'styled-components';
import { Palette } from 'config';

export const Container = styled.div`
  background-color: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: ${({ isReverse }) => isReverse && 'row-reverse'};
  gap: 8px;
`;

export const Button = styled.label`
  background-color: ${Palette.PrimaryGray._400};
  width: 34px;
  height: 20px;
  border-radius: 24px;
  cursor: pointer;
  position: relative;
  transition: 0.2s;
  :hover {
    background-color: ${Palette.PrimaryGray._500};
  }
  ::before {
    position: absolute;
    content: '';
    background-color: #fff;
    width: 14px;
    height: 14px;
    border-radius: 100%;
    right: 14px;
    margin: 3px;
    transition: 0.2s;
  }
`;

export const Input = styled.input`
  display: none;
  :checked + ${Button} {
    background-color: ${Palette.Primary._500};
  }
  :checked + ${Button} {
    :hover {
      background-color: ${Palette.Primary._600};
    }
  }

  :checked + ${Button}::before {
    transform: translateX(14px);
  }
`;

export const Lable = styled.label`
  color: ${Palette.PrimaryGray._700};
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  min-width: 55px;
`;
